import React, {  useState, useEffect, createContext} from 'react';
import { Route, Routes, useNavigate, NavLink} from 'react-router-dom';


import AppMode from './appMode/appMode';

import DevRole from './devRole/devRole';
import License from './license/license';

import { FcSupport, FcManager, FcExport  , FcReadingEbook, FcPrint, FcTimeline } from "react-icons/fc";

function DevTab(props) {

  const [activeTab, setActiveTab] = useState('appMode');

  const navigate = useNavigate();

  useEffect(() => {

    navigate('/devTab/appMode');

  }, []);


  return (
    <div className="card" style={{paddingTop : '0px', userSelect: 'none'}}>
      
      <div>

        <NavLink to="appMode"  onClick={() => setActiveTab('appMode')}>
        <div className={`${activeTab === 'appMode' ? 'tab-two active-link' : 'tab-two'}`}>
          <FcSupport size={35}/>
            <span className="tab-text">App Mode</span>
          </div>
        </NavLink>
        
        <NavLink to="license" className={({isActive}) => (isActive ? "active-user" : 'none')}>
          <div className="tab-six" style={{width: '12%'}}>
          <FcTimeline size={35}/>
            <span className="tab-text">License</span>
          </div>
        </NavLink>

        <NavLink to="devRole" onClick={() => setActiveTab('devRole')}>
            <div className={`${activeTab === 'devRole' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '10%' }}>
              <FcReadingEbook size={35} />
              <span className="tab-text">Roles</span>
            </div>
          </NavLink>


     


      </div>

      

 
      <Routes>

        <Route path='appMode' element= {<AppMode/>}/>
        <Route path='license' element= {<License/>}/>
        <Route path='devRole' element={<DevRole />} /> 
        
      </Routes>

    </div>
  );
}

export default DevTab;
